import React from 'react';
import { DumpTruckFields } from "../types/fields";
import { hexToRGBA } from "../../../@core/utils/hex-to-rgba";
import CustomChip from "../../../@core/components/mui/chip";
import { CustomChipProps } from "../../../@core/components/mui/chip/types";
import { DumpTruckStatusOption } from "../types/dto";
import { getDumpTruckStatusColor } from "../types/typification";

interface DumpTruckStatusChipProps extends CustomChipProps {
    option: DumpTruckStatusOption,
    elevation?: number
}

function DumpTruckStatusChip({ option, elevation, ...rest }: DumpTruckStatusChipProps) {
    const color = getDumpTruckStatusColor(option[DumpTruckFields.StatusCode]);

    return (
        <CustomChip
            label={option[DumpTruckFields.StatusDescription]}
            skin='light'
            sx={{
                height: '22px !important',
                padding: '0 !important',
                lineHeight: '22px !important',
                '& .MuiChip-label': {
                    paddingX: 2,
                },
                color: color,
                backgroundColor: hexToRGBA(color, 0.18),
                boxShadow: elevation,
                ...rest.sx,
            }}
            {...rest}
        />
    );
}

export default DumpTruckStatusChip;
